export { default } from './generateRandomColor'
